import Backend from './Backend'
import { useUser } from 'reactfire'
import { Menu } from '@mantine/core'
import { ExitIcon, PaperPlaneIcon } from '@modulz/radix-icons';
import './App.css'
import settingsImage from './img/settings.svg'
import Papa from 'papaparse';

// ReactFire
import { useFirestore, useFirestoreCollectionData } from 'reactfire';
import { query, orderBy, collection } from 'firebase/firestore';

function Navbar(props) {

	const { data: user } = useUser()

	// All entries query
	const firestore = useFirestore()
	const entryCollection = collection(firestore, 'journals', props.uid, 'entries')
	const entriesQuery = query(entryCollection, orderBy('date', 'desc'))
	const { data: entries } = useFirestoreCollectionData(entriesQuery, {
		idField: 'id'
	})

	// Export data as CSV
	const exportHandler = () => {
		const betterEntries = entries.map(entry => (
			{...entry, date: Backend.timestampToDate(entry.date)}
		))
		let csv = Papa.unparse(betterEntries, {columns: ['date', 'mood', 'tags', 'title', 'content']})
		console.log(csv)
		const filename = "journal-export.csv"

		var blob = new Blob([csv])
		if (window.navigator.msSaveOrOpenBlob)
			window.navigator.msSaveBlob(blob, filename)
		else {
			var a = window.document.createElement('a')
			a.href = window.URL.createObjectURL(blob, { type: 'text/plain' })
			a.download = filename
			document.body.appendChild(a)
			a.click() // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
			document.body.removeChild(a)
		}
	}
	
	return (
		<nav className="navbar">
			<ul className="navbar__list">
				<div className="navbar__left">
					<div className="navbar__item" key="title">Journaloop</div>
				</div>
				<div className="navbar__center">
					<div className={`navbar__item button--view ${props.useJournalView ? 'button--view--selected' : ''}`} onClick={() => props.onUseJournalViewChange(true)}>Journal View</div>
					<div className={`navbar__item button--view ${props.useJournalView ? '' : 'button--view--selected'}`} onClick={() => props.onUseJournalViewChange(false)}>Statistics View</div>
				</div>
				<div className="navbar__right">
				{<div className="navbar__item label--user">
					{user && user.displayName}</div>}
					<Menu control={<div  className="button--settings"><img src={settingsImage} className="nav_button--settings" alt='settings'></img></div>}>
						<Menu.Label>Options</Menu.Label>
						<Menu.Item onClick={() => Backend.logout()} icon={<ExitIcon />}>Logout</Menu.Item>
						<Menu.Item onClick={exportHandler} icon={<PaperPlaneIcon />}>Export Data</Menu.Item>
						{/* <Menu.Item onClick={}>About</Menu.Item> */}
					</Menu>
				</div>
			</ul>
		</nav>
	)
}

export default Navbar